import React from 'react';
import { Button } from 'semantic-ui-react';

export default props => {
  return (
    <Button basic style={styles.closeButton} onClick={props.onClick}>
      ×
    </Button>
  );
};

const styles = {
  closeButton: {
    float: 'left',
    paddingTop: 5,
    paddingBottom: 5,
    color: '#000'
  }
};



// WEBPACK FOOTER //
// ./src/components/CloseButton.js